import React from "react";
import "./components.css";

import { ChevronRight, ChevronLeft } from "lucide-react";

const Pagination = ({ page, pageSize, totalPages, onPageChange, onPageSizeChange }) => {
  
  const pageSizeOptions = [5, 10, 20, 50];
  return (
    <div className="pagination-container">

      {/** Minuses one to the page when you click previous (unless you're at 1). */}
      <button onClick={() => onPageChange(page - 1)} disabled={page <= 1} className="pagination-button pagination-button-secondary">
        <ChevronLeft size={18} />
        <span> Previous </span>
      </button>

      <div className="pagination-info">
        <span className="pagination-text"> Page {page} of {totalPages} </span>
      </div>

      {/** Adds one to the page when you click next, as long as you don't exceed the total page count. */}
      <button onClick={() => onPageChange(page + 1)} disabled={page >= totalPages} className="pagination-button"> 
        <span> Next </span>
        <ChevronRight size={18} />
      </button>


      {/** Controls how many pages are shown per page. You can change it. */}
      <div className="page-size-control">
        <span className="pagination-text"> Show </span>
        <select className="pagination-select" value={pageSize}
        
        onChange={(e) => {const newSize = parseInt(e.target.value, 10);
          onPageSizeChange(newSize);
          onPageChange(1);
        }}>

         {pageSizeOptions.map(size => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
        <span className="pagination-text"> entries </span>
      </div>

    </div>
  );
};

export default Pagination;
